import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Box, Button, Flex, Image, rem, StyleProps } from '@bonusly/design-system';
import { useRecognizeURL } from '@bonusly/url';

import logo from '../../assets/images/bonusly-logo.png';
import { NAVBAR_HEIGHT_IN_PX } from '../../config/layout';
import { AppLayout } from '../Layout';
import { Unauthorized } from './Unauthorized';

interface NavbarShellProps extends StyleProps {
	children?: ReactNode;
	logo: ReactNode;
}

export const NavbarShell: FC<NavbarShellProps> = ({ children, logo, ...props }) => {
	return (
		<Flex alignItems="center" as="nav" h={rem(NAVBAR_HEIGHT_IN_PX)} id="primary-nav" px={{ base: 4, lg: 6 }} w="full" {...props}>
			<Flex w="full" alignItems="center">
				<Flex alignItems="center" flexBasis={0} flexGrow={1} h={rem(40)}>
					<Box as={Link} id="primary-nav-logo" h="full" to="/">
						{logo}
					</Box>
				</Flex>

				{children}
			</Flex>
		</Flex>
	);
};

export const NavFallback: FC = () => {
	const { t } = useTranslation('monarch');

	return (
		<AppLayout navbar={<NavbarShell logo={<Image alt={t('links.company_logo', { name: 'Bonusly' })} h={rem(40)} src={logo} />} />}>
			<Unauthorized
				link={
					<Button as="a" href={useRecognizeURL('/users/sign_in_start')}>
						{t('links.re_login')}
					</Button>
				}
			/>
		</AppLayout>
	);
};
